<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.subscription` | trans }}
    </h1>
    <a slot="buttons" :href="routes.orders_and_invoices" class="btn btn-primary">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      Wróć
    </a>
    <v-app id="vuetify-app" class="no--wrap box box-success">
      <v-container>
        <v-layout justify-center row wrap class="box-body">
          <v-flex xs10>
            <h3 class="subscription-summary__header">Proponowany pakiet:
              <strong>{{ getSubscriptionName() }}</strong> w kwocie <strong>{{ getOrderAmount() | money}}</strong></h3>
            <h4 class="subscription-summary__header header--dates">
              {{ getNewSubscriptionStartDate().format('DD.MM.Y') }} -
              {{ getNewSubscriptionEndDate().format('DD.MM.Y') }} </h4>
          </v-flex>
          <v-flex xs12>
            <v-alert type="info" :value="true">
              <h4>Szanowny Użytkowniku!</h4>
              Jeśli akceptujesz zaproponowany pakiet, kliknij <strong>ZAAKCEPTUJ ZAMÓWIENIE</strong>. Po zatwierdzeniu,
            zostaniesz przekierowany do podsumowania zamówienia i płatności systemem PayU. Jeśli nie zgadzasz się z
            zaproponowaną ofertą, kliknij <strong>ANULUJ</strong> by anulować
            zamówienie.
            </v-alert>
          </v-flex>
        </v-layout>
        <v-layout justify-center class="subscription-summary__footer">
          <v-btn :disabled="formSubmission" :href="routes.orders_and_invoices" color="cancel" dark>Anuluj</v-btn>
          <v-btn :disabled="submitButtonDisabled" color="primary" @click="assignIndividualOrder()">
            Zaakceptuj
            zamówienie
          </v-btn>
        </v-layout>
      </v-container>
      <v-dialog v-model="acceptingDisabled" width="800" :persistent="true">
        <order-invoice-form @saved="acceptingDisabled = false">
          <template v-slot:title>
            <v-toolbar card dark color="primary">
              <v-toolbar-title>{{ 'app.invoice.data' | trans }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:body>
            <v-alert type="warning" :value="true">
                Przed akceptacją, należy uzupełnić dane do faktury.
            </v-alert>
          </template>
        </order-invoice-form>
      </v-dialog>
    </v-app>
  </base-layout>
</template>

<script>
import { newSubscriptionEndDate, newSubscriptionStartDate } from '../../utils/subscription'

export default {
  props: {
    routes: Object,
    current_subscription: Object,
    last_subscription: Object,
    order: Object,
    invoice_missing: Boolean,
  },
  data: () => ({
    formSubmission: false,
    acceptingDisabled: false,
  }),
  created() {
    this.acceptingDisabled = this.invoice_missing;
  },
  computed: {
    submitButtonDisabled () {
      return this.formSubmission === true || this.acceptingDisabled === true;
    },
  },
  methods: {
    assignIndividualOrder () {
      this.formSubmission = true

      axios.put(this.routes.assign_individual_order)
          .then((response) => {
            window.location.href = response.data.redirect_route
          }).catch((error) => {
            this.$toast.error('Nie udało się zaakceptować zamówienia');
            this.sentryCaptureException(error);
          }).finally(() => {
            this.formSubmission = false
          });
    },
    getNewSubscriptionStartDate () {
      return newSubscriptionStartDate(false, this.current_subscription, this.last_subscription)
    },
    getNewSubscriptionEndDate () {
      return newSubscriptionEndDate(
          this.order.duration,
          false,
          this.current_subscription,
          this.last_subscription
      )
    },
    getSubscriptionName () {
      switch (this.order.role_to_assign) {
        case 'dietitian_premium':
          return 'Premium'
        case 'dietitian_standard':
          return 'Standard'
        default:
          return 'Student'
      }
    },
    getOrderAmount () {
      return Number(this.order.amount);
    }
  }
}
</script>
